module.exports = __webpack_public_path__ + "static/media/q-mask-no-center.3dcae1ff.svg";